import React, { createContext, useContext } from "react";

import { useAuthSession } from "../../lib/auth/session";
import { ChatContextValue } from "./types";
import { useChatController } from "./hooks/useChatController";
import { createDefaultSnapshot } from "./utils/snapshot";

const ChatContext = createContext<ChatContextValue | null>(null);

export const ChatProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { officerId } = useAuthSession();
  const value = useChatController({ currentUserId: officerId });
  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};

export function useChat(): ChatContextValue {
  const context = useContext(ChatContext);
  if (!context) {
    return {
      snapshot: createDefaultSnapshot(),
      activeConversationId: null,
      activeConversation: null,
      loadingSnapshot: true,
      error: "Chat context is unavailable",
      setActiveConversation: () => {
        throw new Error("ChatProvider is missing from component tree");
      },
      loadConversation: async () => {
        throw new Error("ChatProvider is missing from component tree");
      },
      sendMessage: async () => {
        throw new Error("ChatProvider is missing from component tree");
      },
      createConversation: async () => {
        throw new Error("ChatProvider is missing from component tree");
      },
      markConversationAsRead: async () => {
        throw new Error("ChatProvider is missing from component tree");
      },
      refreshSnapshot: async () => {
        throw new Error("ChatProvider is missing from component tree");
      },
    };
  }
  return context;
}

